import { InMemoryCache } from "@apollo/client/cache";
import { ApolloClient } from "@apollo/client/core/index.js";
import { createHttpLink } from "@apollo/client/link/http";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { ApolloProvider } from "@apollo/client/react/context/ApolloProvider";
import { MultiAPILink } from "@habx/apollo-multi-endpoint-link";
import { createClient } from "graphql-ws";

interface GraphQLProviderProps {
  children: React.ReactNode;
  graphqlUrl?: string;
  accessToken?: string;
  creatorGraphqlUrl?: string;
}

export function GraphQLProvider({
  children,
  accessToken,
  graphqlUrl,
  creatorGraphqlUrl,
}: GraphQLProviderProps) {
  if (!graphqlUrl || !creatorGraphqlUrl) {
    return <>{children}</>;
  }

  const httpLink = new MultiAPILink({
    endpoints: {
      default: graphqlUrl,
      creator: creatorGraphqlUrl,
    },
    getContext(endpoint) {
      if (endpoint === "creator") {
        return {
          headers: {
            Authorization: accessToken,
          },
        };
      }
      return {};
    },
    wsSuffix: "",
    httpSuffix: "",
    defaultEndpoint: "default",
    createWsLink(endpoint) {
      if (endpoint === "creator") {
        return new GraphQLWsLink(
          createClient({
            url: new URL(graphqlUrl).toString().replace(/^http/, "ws"),
          }),
        );
      }
      return new GraphQLWsLink(
        createClient({
          url: new URL(creatorGraphqlUrl).toString().replace(/^http/, "ws"),
          connectionParams: () => {
            return {
              Authorization: `Bearer ${accessToken}`,
            };
          },
        }),
      );
    },
    createHttpLink: () => createHttpLink(),
  });

  const apolloClient = new ApolloClient({
    ssrMode: true,
    link: httpLink,
    cache: new InMemoryCache(),
  });

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}
